// Business Registration Utility Functions

// Utility to capitalize strings
const capitalize = (str) =>
  typeof str === 'string' && str.length > 0
    ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    : '';

export const formatOwnerName = (owner) => {
  if (owner.full_name) {
    return owner.full_name;
  }
  return `${capitalize(owner.first_name || '')} ${capitalize(owner.middle_name || '')} ${capitalize(owner.last_name || '')}`.trim();
};

export const buildBusinessAddress = (data) => {
  const parts = [
    data.street_name,
    data.purok_zone,
    data.barangay,
    data.municipality,
    `${data.province} ${data.zip_code || ''}`.trim(),
  ].filter(Boolean);
  
  return parts.join(', ');
};
